import React, {useState, useEffect} from 'react'
import Topbar from '../../components/landingTopbar'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import validator from 'validator'






import TextInputField from '../../components/inputText'
import LoadingButton from '../../components/loadingButton'
import RegistrationModel from '../../components/models/RegistrationModel';
import SetPasswordModel from '../../components/models/setPasswordModel';
import {signinAction} from '../../actions'
import NotificationMessage from '../../components/notificationMessage';
import Accordions from '../../components/accordion';
import {submitRegistration} from '../../actions'
import {REGISTRATION_LOADING_ID, SIGNIN_LOADING_ID} from '../../store/loaders'









const Membership = ()=>{

    const history = useHistory()
    const dispatch = useDispatch()


    const [show, setShow] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [changeView, setChangeView] = useState(true)
    const [password, setPassword] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [passwordError, setPasswordError] = useState('')
    const [phoneNumberError, setPhoneNumberError] = useState('')





    //registration Model

    const [individualInputs,setIndividualInputs] = useState({
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        email: '',
        password: '',
        confirmPassword: '',
    })

    const [individualError,setIndividualError] = useState({
        firstName: false,
        lastName: false,
        telephoneNumber: false,
        email: false,
        password: false,
        confirmPassword: false,
        emailHelperText: '',
        firstNameHelperText: '',
        lastNameHelperText: '',
        phoneNumberHelperText: '',
        passwordHelperText: '',
        confirmPasswordHelperText: ''
    })



    const [signinStatus,
        setSigninStatus] = useState('')

    const apiResponse = useSelector(state=>{
        const {signIn, loader,registration, membershipGrade, signinStatus} = state
        const {registered} = registration
        const {grades} = membershipGrade
        const {isLoading} = loader[REGISTRATION_LOADING_ID] || {isLoading: false}
        const signInLoader = loader[SIGNIN_LOADING_ID] || false
        const {currentUser} = signIn
        const {status} = signinStatus
        return{
            currentUser,
            isLoading,
            registered,
            grades,
            signInLoader: signInLoader.isLoading,
            status
        }
    })
    const actionLoader = apiResponse.isLoading
    const loginLoader = apiResponse.signInLoader

    const token = localStorage.getItem('Token')

    const [regResponse, 
        setResponse] = useState('')

    useEffect(()=>{
        if(apiResponse.currentUser && apiResponse.currentUser.sub !== '' && token ){
            localStorage.setItem('currentUser', JSON.stringify(apiResponse.currentUser))
            if(apiResponse.currentUser?.email_verified === false){
                setSigninStatus('Please verify your email first')
                return
            }
            if(apiResponse.currentUser?.firstLogin === true){
                history.push('/applicant')
            }else{
                history.push('/dashboard')
            }
        }
    },[apiResponse.currentUser])

    useEffect(()=>{
        if(apiResponse.registered && apiResponse.registered){
            setChangeView(false)
            setResponse(apiResponse?.registered)
        }
        // dispatch(fetchMembershipGrade())
    },[apiResponse.registered])

  

    useEffect(()=>{
        if(apiResponse.status){
            setSigninStatus(apiResponse.status?.error_description)
        }
    },[apiResponse.status])



    const handleIndividualRegistration = ()=>{
        if(individualInputs.firstName === ''){
            setIndividualError({
                ...individualError,
                firstName: true,
                firstNameHelperText: 'Invalid name'
            })
            return
        }
        if(individualInputs.lastName === ''){
            setIndividualError({
                ...individualError,
                lastName: true,
                lastNameHelperText: 'Invalid name'
            })
            return
        }
        if(individualInputs.telephoneNumber === ''){
            setIndividualError({
                ...individualError,
                telephoneNumber: true,
                phoneNumberHelperText: 'Invalid phone number'
            })
            return
        }
        if(individualInputs.email === '' || !validator.isEmail(individualInputs.email)){
            setIndividualError({
                ...individualError,
                email: true,
                emailHelperText: 'Invalid Email'
            })
            return
        }
        if(individualInputs.password === ''){
            setIndividualError({
                ...individualError,
                password: true,
                passwordHelperText: 'Invalid Password'
            })
            return
        }
        if(individualInputs.confirmPassword === ''){
            setIndividualError({
                ...individualError,
                confirmPassword: true,
                confirmPasswordHelperText: 'Invalid Password'
            })
            return
        }
        if(individualInputs.password !== individualInputs.confirmPassword){
            setIndividualError({
                ...individualError,
                password: true,
                confirmPassword: true,
                confirmPasswordHelperText: 'Password does not match'
            })
            return
        }
        dispatch(submitRegistration({
            firmInputs:individualInputs
        }))
    }   


    const handleToggleModal = ()=>{
        setShow(!show)
        setChangeView(true)
    }

    const togglePasswordModel = ()=>{
        setShowPassword(!showPassword)
        setChangeView(true)
    }
    const toggleRegistrationModel = ()=>{
        // setChangeView(false)
    }

    const handleUserNameChange = (phoneNumber)=>{
        setPhoneNumber(phoneNumber)
        setPhoneNumberError('')
    }

    const handlePasswordChange = (password)=>{
        setPassword(password)
        setPasswordError('')
    }

    const handleLogin= ()=> {
        if(phoneNumber === ''){
            setPhoneNumberError('Username can not be empty')
            return 
        }
        if(password === '' || phoneNumber === ''){
            setPasswordError("Password can not be empty")
            return 
        }
        if(password !== '' && phoneNumber !== ''){
            dispatch(signinAction({
                phoneNumber,
                password
            }))
            sessionStorage.setItem('steps', true)
        }
    }

    const handleKeyPress = (e)=>{
        if(e.which === 13) {
            if(phoneNumber === ''){
                setPhoneNumberError('Username can not be empty')
                return 
            }
            if(password === '' || phoneNumber === ''){
                setPasswordError("Password can not be empty")
                return 
            }
            if(password !== '' && phoneNumber !== ''){
                dispatch(signinAction({
                    phoneNumber,
                    password
                }))
                sessionStorage.setItem('steps', true)
            }
          }
    }   

    const handleCloseNotificationMessage = ()=>{
        setSigninStatus('')
    }
   

    return(
        <>
        <Topbar/>
        <div className="membership-container">
           <div className="membership-left-ctn">
               <div className="mb-4 d-flex" style={{flexDirection: 'column'}}>
                    <p>
                        Welcome to IER Membership Digital Portal
                    </p>
                    <span className="welcome-text">
                        Welcome to IER Digital Portal, <br/>
                        In order to provide seamless services to our esteemed members, a new Membership Digital Portal (MDP) has been established. New applicants wishing to join the institution MUST apply through the online portal. Existing Members who wish to renew their practicing certificate MUST apply through the same portal N.B: In case of any challenge,
                        please contact telephone <a style={{cursor: 'pointer', color: 'blue', textDecoration: 'underline'}}>0789904228</a>, email: <a style={{cursor: 'pointer', color: 'blue', textDecoration: 'underline'}}>admissions@engineersrwanda.rw</a>.                        
                    </span>
               </div>
            <Accordions/>
           </div>
           <div className="membership-right-ctn">
               <div className="login-ctn">
                  { signinStatus !== '' &&
                    <NotificationMessage
                        signinStatus={signinStatus}
                        handleCloseNotificationMessage={handleCloseNotificationMessage}/> }
                   <p>
                        Members Access
                   </p>
                   <TextInputField
                        placeholder="Enter username"
                        error={phoneNumberError}
                        handleChange={handleUserNameChange}
                        onKeyPress={handleKeyPress}
                        />
                    <br/>
                   <TextInputField
                        placeholder="Enter password"
                        error={passwordError}
                        isPassword={true}
                        handleChange={handlePasswordChange}
                        onKeyPress={handleKeyPress}/>
                    <div style={{ 
                        width: '70%', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        marginTop: 10
                        }}>
                        <LoadingButton
                            text="Login"
                            handleLogin={handleLogin}
                            disabled={loginLoader}/>
                    </div>
                    <div style={{ 
                            width: '70%', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            marginTop: 10,
                            
                            }}>
                        <LoadingButton
                            text="REGISTER NOW"
                            handleLogin={handleToggleModal}
                            style={{border: '3px solid #1D834F', backgroundColor: 'white'}}
                            textStyles={true}
                            />
                    </div>
                    <span
                        onClick={togglePasswordModel} 
                        className="forgot-password mt-2 mb-5">Did you forget password?
                    </span>
               </div>
           </div>
           <RegistrationModel 
                show={show} 
                hide={handleToggleModal}
                changeView={changeView}
                individualInputs ={individualInputs}
                setIndividualInputs={setIndividualInputs}
                handleIndividualRegistration = {handleIndividualRegistration}
                individualError={individualError}
                setIndividualError={setIndividualError}
                disabled={actionLoader}
                email={individualInputs.email}
                regResponse={regResponse}/>
           <SetPasswordModel 
                show={showPassword} 
                hide={togglePasswordModel}
                changeView={changeView}
                setChangeView={setChangeView}
                toggleRegistrationModel = {toggleRegistrationModel}
                />
        </div>
        </>
    )
}


export default Membership 